var changePlaceholderText = (function () {

    var setUpChangePlaceholderText = function () {
        function changePlaceholder(){
            if($('.c-return-point-result').length){
              if($(window).width() < 768){
                $('#location-search').attr("placeholder", "For example Fairfield or 2000");
              }else{
                $('#location-search').attr("placeholder", "For example Fairfield, Moree or 2000");
              }
            }else{
              if($(window).width() < 768){
                $('#location-search').attr("placeholder", "E.g. Fairfield or 2000");
              }else{
                $('#location-search').attr("placeholder", "E.g. Fairfield, Moree or 2000");
              }
            }
          }
        // changePlaceholder();
        // $( window ).resize(function(){
        //     changePlaceholder();
        // });
    };

    var init = function () {
      setUpChangePlaceholderText();
    };

    return {
      init: init
    };
  })();

  export default changePlaceholderText;



// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/changePlaceholderText.js